import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useStateMachine } from 'little-state-machine';
import updateAction from '../updateAction';

import Button from '../components/Button';

import heroImage from '../../assets/hero-bg@3x.png';
import heroImageDesktop from '../../assets/congrats-bg.svg';
import tickImage from '../../assets/tick-blanco-icn.svg';
import tickOrangeImage from '../../assets/tick-orange-icn.svg';
import horarioImage from '../../assets/horario.svg';
import tarjetaImage from '../../assets/tarjeta.svg';
import { click_finish } from '../techspec';

import useStore from '../store';
import useMatchMedia from '../useMatchMedia';

import { cards } from '../data';
import {
  getPickupInfo,
  clearSessionStorage,
  redirectToLanding,
  breakpoints,
  colors,
} from '../config';
import LikertSlider from '../components/LikertSlider';
import CuentaPocket from '../components/CuentaPocket/CuentaPocket';
import { getButtonId, getParameters } from '../functions';

const Success = props => {
  const [{ selectedGroup, selectedCard }, setStore] = useStore();
  const isDesktop = useMatchMedia(`(min-width: ${breakpoints.md})`);
  const { state } = useStateMachine(updateAction);

  const [urlData, setUrlData] = useState('');

  useEffect(() => {
    const parametros = getParameters();
    setUrlData({ step: '/success', tipo: parametros?.tipo });
  }, []);

  const likerReq = {
    numero_cedula: state.data.numero_cedula,
    tipo_cedula: state.data.tipo_cedula,
    solicitudId: state.data.solicitudId,
  };

  const pickupInfo = getPickupInfo(state?.data?.pickup || 'UES Centro', state?.data?.zona);

  function getCards(cardId) {
    return cards.find(card => card.id === cardId);
  }

  function getCardTypes(cardId, types) {
    return types.find(card => card.id === cardId);
  }

  let group = getCards(selectedGroup);
  let card = getCardTypes(selectedCard, group?.types);
  const cardImage = card?.image;

  function handleExit() {
    click_finish();
    clearSessionStorage();
    redirectToLanding();
  }

  return (
    <>
      <div className="success-art" />

      <div className="success">
        {isDesktop ? (
          <div className="success-hero-desktop">
            <h1>
              <motion.div
                initial={{ scale: 0, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ duration: 1, type: 'spring' }}
              >
                <img src={tickOrangeImage} alt="" width={34} />
              </motion.div>
              <span>
                <motion.div
                  initial={{ /* height: 0, */ opacity: 0 }}
                  animate={{ /* height: 76, */ opacity: 1 }}
                  transition={{ duration: 0.5 }}
                >
                  ¡Tu solicitud fue enviada!
                </motion.div>
              </span>
            </h1>
            <motion.div
              initial={{ x: 200, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ duration: 1, ease: 'anticipate' }}
            >
              <div className="success-image">
                <img src={cardImage} alt="" />
              </div>
            </motion.div>
          </div>
        ) : (
          <div className="success-hero">
            <div className="success-image">
              <img src={cardImage} alt="" />
            </div>
            <h1>
              <img src={tickImage} alt="" width={34} />

              <span>¡Tu solicitud fue enviada!</span>
            </h1>
          </div>
        )}

        <div className="success-content">
          <LikertSlider likertReq={likerReq} />

          <div className="form-actions">
            <Button
              block
              onClick={handleExit}
              id={
                urlData && getButtonId(urlData?.tipo, '/success')
                  ? getButtonId(urlData?.tipo, '/success')
                  : 'success-button'
              }
            >
              Terminar
            </Button>
          </div>
        </div>
      </div>

      <style jsx>{`
        .success-art {
          background-image: url(${heroImageDesktop});
          width: 800px;
          height: 1000px;
          background-position: top left;
          background-repeat: no-repeat;
          position: absolute;
          top: -633px;
          right: -15%;
          display: none;
        }

        @media screen and (min-width: 1400px) {
          .success-art {
            right: 3%;
          }
        }

        @media screen and (min-width: ${breakpoints.md}) {
          .success {
            max-width: 768px;
            margin: 0 auto;
          }

          .success-art {
            display: block;
          }
        }

        :global(.art) {
          display: none;
        }

        :global(#itau-tc .container) {
          width: 100% !important;
        }

        .success-hero {
          background-image: url(${heroImage});
          background-position: center bottom;
          background-repeat: no-repeat;
          background-size: cover;
          color: #fff;
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 32px 32px 16% 32px;
          align-items: center;
        }

        .success-image {
          overflow: hidden;
          border-radius: 12px;
          margin-bottom: 32px;
          max-width: 420px;
          box-shadow: 0 12px 30px 0 rgba(0, 0, 0, 0.08), 0 2px 5px 0 rgba(43, 43, 43, 0.05),
            0 12px 30px 0 rgba(168, 90, 12, 0.2);
        }

        .success-image img {
          width: 100%;
          height: auto;
          vertical-align: middle;
        }

        @media screen and (max-width: ${breakpoints.md}) {
          .success-content {
            padding: 32px;
          }
        }

        ul {
          list-style: none;
          margin: 0;
          margin-bottom: 48px;
          margin-top: 24px;
          padding: 0;
          box-shadow: 0px 0px 3px rgba(16, 25, 32, 0.05), 0px 2px 4px rgba(6, 21, 33, 0.05);
          background-color: #fff;
          padding: 24px;
        }

        @media screen and (min-width: ${breakpoints.md}) {
          ul {
            border-radius: 4px;
            padding: 32px 24px;
            display: flex;
            margin-top: 0;
          }

          ul li {
            flex: 1 0 0%;
            margin-bottom: 0;
          }

          ul li + li {
            margin-left: 32px;
          }
        }

        li {
          background-position: left 1px;
          background-repeat: no-repeat;
          margin: 0;
          margin-bottom: 38px;
          padding-left: 38px;
          position: relative;
        }

        @media screen and (max-width: ${breakpoints.md}) {
          ul li:first-child:before {
            border-left: 1px dashed ${colors.orange};
            content: '';
            height: 100%;
            left: 12px;
            position: absolute;
            top: 32px;
            width: 1px;
          }
        }

        .item-tarjeta {
          background-image: url(${tarjetaImage});
        }

        .item-horario {
          background-image: url(${horarioImage});
        }

        .success-hero h1 {
          color: #fff;
          display: flex;
          font-size: 22px;
          line-height: 1.35;
          margin: 0;
          align-items: center;
        }

        h1 span {
          flex: 1 0 0%;
          margin-left: 20px;
        }

        .success-hero-desktop {
          display: flex;
          align-items: center;
          justify-content: space-between;
          z-index: 100;
          position: relative;
          padding-top: 52px;
        }

        .success-hero-desktop h1 {
          font-weight: 900;
          font-family: ${colors.baseFontDisplay};
          font-size: 32px;
          display: flex;
          align-items: center;
          margin-right: 80px;
          line-height: 1.2;
        }

        .success-hero-desktop .success-image {
          max-width: 330px;
          margin-bottom: 16px;
          box-shadow: 0 64px 64px 0 rgba(89, 76, 58, 0.05), 0 32px 32px 0 rgba(120, 109, 61, 0.05),
            0 16px 16px 0 rgba(82, 69, 55, 0.05), 0 8px 8px 0 rgba(125, 109, 72, 0.05),
            0 4px 4px 0 rgba(125, 114, 64, 0.05), 0 2px 2px 0 rgba(115, 102, 63, 0.05);
        }

        h2 {
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 32px;
          margin-top: 0;
        }

        @media screen and (min-width: ${breakpoints.md}) {
          h2 {
            margin-bottom: 24px;
          }
        }

        h3 {
          color: ${colors.black};
          font-size: 18px;
          font-weight: 800;
          margin-bottom: 10px;
          margin-top: 0;
          line-height: 1.5;
        }

        p {
          margin-bottom: 10px;
          margin-top: 0;
        }

        .tip {
          color: ${colors.textMuted};
          font-size: 14px;
        }

        .tip strong {
          color: ${colors.orange};
          font-weight: 800;
          text-transform: uppercase;
        }

        .form-actions {
          margin-bottom: 32px;
        }
      `}</style>
    </>
  );
};

export default withRouter(Success);
